module.exports = __webpack_public_path__ + "static/img/vision.354c9aa6.png";